import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Box from '@material-ui/core/Box';
import Alert from '@material-ui/lab/Alert';
import AcceptedTerms from './accepted-terms';
import HostModifyBookingSection from './host-modify-booking-section';

const IsHostBookingPaid = ({ booking, disableButtons }) => {
  return (
    <Box>
      <Box style={{ marginBottom: '10px' }}>
        <AcceptedTerms booking={booking} />
      </Box>
      <HostModifyBookingSection booking={booking} disableButtons={disableButtons} />
      <Alert severity="info" elevation={3}>
        <FormattedMessage
          id="bookingInfo.paidHost"
          defaultMessage="To cancel this booking contact support at info@stugknuten.com"
        />
      </Alert>
    </Box>
  );
};

IsHostBookingPaid.propTypes = {
  booking: PropTypes.shape({}),
  disableButtons: PropTypes.bool,
};

IsHostBookingPaid.defaultProps = {
  disableButtons: false,
};

export default IsHostBookingPaid;
